import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description RoundCheck icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RoundCheck } from '@sravni/design-system-icons'
 *
 * <RoundCheck />
 * ```
 */
var RoundCheck = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "RoundCheck", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M10.736 17.25A7.25 7.25 0 0 1 3.486 10a7.25 7.25 0 0 1 7.25-7.25 7.25 7.25 0 0 1 7.25 7.25 7.25 7.25 0 0 1-7.25 7.25Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m14.292 8.222-4.445 4.445L7.181 10", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { RoundCheck };
//# sourceMappingURL=RoundCheck.js.map
